import { animationTransition } from '@shared/joykit/packages/core/utils';
import { styled, Box, TextV1 } from '@withjoy/joykit';
import { DialogV1 } from '@withjoy/joykit';

export const PhotoBox = styled(Box)<{ currentEvent?: boolean }>`
  transition: all 0.5s;
  border: ${props => (props.currentEvent ? `2px solid ${props.theme.colors.stroke}` : undefined)};
  > div {
    transition: all 0.5s;
  }
`;

export const Container = styled(Box)`
  > *:not(:last-child) {
    margin-bottom: 24px;
  }
`;

export const Row = styled(Box)<{ currentEvent?: boolean }>`
  :hover {
    cursor: pointer;
    color: ${props => props.theme.colors.stroke};

    ${PhotoBox} {
      filter: ${props => (props.currentEvent ? 'drop-shadow(0px 0px 12px rgba(113, 57, 191, 0.25))' : undefined)};
      > div {
        transform: scale(1.2);
      }
    }
  }
`;

export const StyledDialog = styled(DialogV1)`
  > div > div {
    overflow: scroll;
    max-height: 520px;
    max-width: 422px;
    min-width: 422px;
  }

  > div > div > div {
    padding-top: 0px;
    padding-right: 32px;
    padding-left: 32px;
  }

  .joykit-dialog-header {
    padding: 0px;
    background-color: ${props => props.theme.colors.white};
    border-bottom: 1px solid ${props => props.theme.colors.mono3};
    margin-bottom: 28px;
    min-height: unset;
    > span > svg {
      top: -24px;
      position: absolute;
      left: -28px;
    }
  }
`;

export const StyledCaption = styled(TextV1)`
  color: ${props => props.theme.colors.white};
`;

export const CreateNewButton = styled.button`
  margin: 32px 0;
  color: ${props => props.theme.colors.mono14};
  font-size: 17px;
  font-weight: 600;
  line-height: 24px;
  letter-spacing: -0.01em;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: transparent;
  width: 100%;
  padding: 24px 0;
  transition: ${animationTransition('background-color', 'color')};
  border-radius: 8px;
  :hover {
    cursor: pointer;
    color: ${props => props.theme.colors.strokeHover};
    background-color: ${props => props.theme.colors.mono1};
  }
`;
